import { Modal, Space } from 'antd';
import { Trans } from 'react-i18next';

import { JobPostingActionModal } from './VacancyActions';

const ConcludeVacancyModal: React.FC<JobPostingActionModal> = ({ jobPosting, ...props }) => {
  const jobPostingName = jobPosting.name;
  const jobPostingPositions = jobPosting.positions;
  const jobPostingFilledPositions = jobPosting.filled_positions;

  return (
    <Modal {...props}>
      <Space direction="vertical">
        {jobPostingFilledPositions < jobPostingPositions && (
          <span>
            <Trans values={{ jobPostingName, jobPostingFilledPositions, jobPostingPositions }}>
              A vaga <strong>{{ jobPostingName }}</strong> não pode ser concluída, pois tem apenas{' '}
              {{ jobPostingFilledPositions }} pessoa(s) contratada(s) que é inferior a quantidade de{' '}
              {{ jobPostingPositions }} posições definidas durante a abertura da vaga. Altere o
              número de posições editando a vaga antes de concluí-la.
            </Trans>
          </span>
        )}
        {jobPostingFilledPositions >= jobPostingPositions && (
          <>
            <span>
              <Trans>
                Lembrete: Você já <b>enviou feedback para todos os candidatos?</b> Lembre-se que
                falta de retorno do processo seletivo é o principal motivo de insatisfação com a
                empregadora e isso pode afetar a sua atração no longo prazo.
              </Trans>
            </span>
            <div>
              <Trans values={{ jobPostingName }}>
                Tem certeza que deseja concluir a vaga <strong>{{ jobPostingName }}</strong>?
              </Trans>
            </div>
          </>
        )}
      </Space>
    </Modal>
  );
};

export default ConcludeVacancyModal;
